/** @format */

import React from "react";
import { useFieldStackSpacing } from "../fieldStackContext";
import ValidityCheck from "./validityCheck";

const TextInput = ({
  id,
  type,
  placeholder,
  register,
  disabled,
  autoComplete,
  maxLength,
  classNamelic,
  errors,
  showValidIcon,
  tooltipText,
  onChange,
  onInput,
  prefix,
  ...props
}) => {
  const isInFieldStack = useFieldStackSpacing();
  const hasPrefix = Boolean(prefix);
  const numberInputClasses =
    type === "number"
      ? "tw-appearance-none [&::-webkit-inner-spin-button]:tw-appearance-none [&::-webkit-outer-spin-button]:tw-appearance-none"
      : "";

  return (
    <div
      className={`tw-group tw-relative tw-w-full ${isInFieldStack ? "" : "tw-mt-2.5"}`}
    >
      {hasPrefix && (
        <span
          className={`tw-pointer-events-none tw-absolute tw-left-0 tw-top-0 tw-z-[1] tw-flex tw-h-12 tw-w-12 tw-box-border tw-items-center tw-justify-center tw-rounded-l-lg tw-text-base tw-font-semibold tw-text-dis-navy ${errors ? "tw-border-0 tw-border-b-2 tw-border-solid tw-border-dis-error tw-bg-dis-error-bg-strong" : "tw-bg-dis-border"}`}
          aria-hidden="true"
        >
          {prefix}
        </span>
      )}
      <input
        {...props}
        autoComplete={autoComplete ?? "off"}
        disabled={disabled}
        onChange={onChange}
        placeholder={placeholder}
        type={type}
        id={id}
        className={`tw-m-0 tw-box-border tw-block tw-h-12 tw-w-full tw-rounded-lg tw-border-0 tw-border-b-2 tw-border-solid ${errors ? "tw-border-dis-error tw-bg-dis-error-bg" : "tw-border-dis-field-edge tw-bg-dis-field hover:tw-bg-dis-field-hover"} tw-py-0 ${hasPrefix ? "tw-pl-16" : "tw-pl-[15px]"} tw-pr-10 tw-text-base tw-text-dis-navy tw-outline-none tw-shadow-none tw-transition-colors focus:tw-outline-none focus:tw-shadow-none [caret-color:#000] placeholder:tw-text-base placeholder:tw-text-dis-placeholder ${numberInputClasses} ${classNamelic || ""}`}
        {...register}
        maxLength={maxLength}
        onInput={onInput}
      />
      {showValidIcon && <ValidityCheck />}
      {tooltipText && (
        <span className="tw-invisible tw-absolute tw-left-0 tw-top-[-44px] tw-z-[999] tw-w-[clamp(250px,90vw,413px)] tw-rounded-[11px] tw-bg-white tw-p-[7px] tw-text-gray-500 tw-opacity-0 tw-transition-opacity group-hover:tw-visible group-hover:tw-opacity-100">
          {tooltipText}
        </span>
      )}
    </div>
  );
};

export default TextInput;
